// extracted by mini-css-extract-plugin
module.exports = {"customerItem":"profilecustomer_customerItem__1SO2o","customerItemIcon":"profilecustomer_customerItemIcon__2cQvH","customerItemActive":"profilecustomer_customerItemActive__17Kf4"};